__turbopack_context__.v({
  "ctaButtons": "HeroSection-module__LBSttG__ctaButtons",
  "heroContent": "HeroSection-module__LBSttG__heroContent",
  "heroImage": "HeroSection-module__LBSttG__heroImage",
  "heroTextContent": "HeroSection-module__LBSttG__heroTextContent",
  "root": "HeroSection-module__LBSttG__root",
});
